import type { IntlKey } from 'locales';
import { ChangeEvent, FC, FocusEvent, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

type TextAreaProps = {
  id: string;
  value: string | undefined;
  placeholder?: IntlKey;
  onValueChanged: (newValue: string) => void;
  rows: number;
};

export const TextArea: FC<TextAreaProps> = ({ id, placeholder, value, onValueChanged, rows }) => {
  const { formatMessage } = useIntl();
  const [editedText, setEditedText] = useState<string | null>(null);
  const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setEditedText(e.target.value);
  }, []);
  const handleBlur = useCallback(
    (_: FocusEvent<HTMLTextAreaElement>) => {
      if (editedText !== null && editedText !== value) {
        onValueChanged(editedText);
      }
    },
    [editedText, onValueChanged, value],
  );

  return (
    <textarea
      className="form-control"
      id={id}
      placeholder={placeholder === undefined ? undefined : formatMessage({ id: placeholder })}
      value={editedText ?? value}
      onChange={handleChange}
      onBlur={handleBlur}
      rows={rows}
    />
  );
};
